module.exports = __webpack_public_path__ + "static/media/vehicle-placeholder.c4704d6d.jpg";